import { render, staticRenderFns } from "./mallBanner.vue?vue&type=template&id=04856d96&scoped=true&"
import script from "./mallBanner.vue?vue&type=script&lang=js&"
export * from "./mallBanner.vue?vue&type=script&lang=js&"
import style0 from "./mallBanner.vue?vue&type=style&index=0&id=04856d96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04856d96",
  null
  
)

export default component.exports